var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 131,
    viewBox: "0 0 360 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_422_2678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H360V131H34C15.2223 131 0 115.778 0 97V0Z",
    fill: "#2A0969"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.2202,
    cy: -30.7798,
    r: 135.465,
    transform: "rotate(-34.7312 16.2202 -30.7798)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.5421,
    cy: -30.9027,
    r: 119.385,
    transform: "rotate(-34.7312 15.5421 -30.9027)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.2203,
    cy: -30.7798,
    r: 98.4314,
    transform: "rotate(-34.7312 16.2203 -30.7798)",
    stroke: "#7ABFEB",
    strokeOpacity: 0.08,
    strokeWidth: 3.89827
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.922 -19.9694L286.378 66.3077L323.241 88.7235L360.104 111.139L432.778 67.5582L433.515 -18.7343L361.596 -63.5505L288.922 -19.9694Z",
    stroke: "#301873",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.334 -8.37488L305.453 55.0335L332.76 71.5096L360.068 87.9857L413.898 55.9598L414.44 -7.46002L361.164 -40.4008L307.334 -8.37488Z",
    stroke: "#301873",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.119 1.1177L321.8 45.8155L340.914 57.4286L360.028 69.0417L397.711 46.4639L398.093 1.75811L360.801 -21.4602L323.119 1.1177Z",
    stroke: "#301873",
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_422_2678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 131,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBackground);
export default __webpack_public_path__ + "static/media/header-background.c4551557c0a589e9907393f7b2faced1.svg";
export { ForwardRef as ReactComponent };